import { ENVIRONMENT } from '@app/environment';
import { SocialModule } from '@core/services/social';
import { Bootstrap } from '@rxdi/core';
import { switchMap } from 'rxjs';

import { AppModule } from './app/app.module';

const social = Bootstrap(
  SocialModule.forRoot({
    apiKey: ENVIRONMENT.GOOGLE_API_KEY,
    authDomain: ENVIRONMENT.GOOGLE_AUTH_DOMAIN,
    databaseURL: ENVIRONMENT.GOOGLE_DATABASE_URL,
    projectId: ENVIRONMENT.GOOGLE_PROJECT_ID,
    storageBucket: ENVIRONMENT.GOOGLE_STORAGE_BUCKET,
    messagingSenderId: ENVIRONMENT.GOOGLE_MESSAGE_SENDER_ID,
    appId: ENVIRONMENT.GOOGLE_APP_ID,
    measurmentId: ENVIRONMENT.GOOGLE_MEASUREMENT_ID,
  })
);
window.addEventListener('load', () => {
  social
    .pipe(
      switchMap(() =>
        Bootstrap(AppModule, {
          init: false,
        })
      )
    )
    .subscribe(
      () => console.log('App Started!'),
      (err) => console.error(err)
    );
});

if (module['hot']) {
  module['hot'].dispose(() => (document.body.innerHTML = ''));
}
